export default "__VITE_ASSET__CDO2AXs4__"